import TaxRateService from "@/store/services/taxrate.service.js";

export default {
  namespaced: true,
  state: {
    invoiceToEdit: {},
    invoiceNumber: '',
    invoiceFilters: {},
    tempInvoiceList: [],
    companyTaxRates: null,
    creditableStatuses: ['sent', 'sending', 'paid', 'overdue']
  },
  getters: {
    getInvoiceToEdit: state => state.invoiceToEdit,
    getInvoiceNumber: state => state.invoiceNumber,
    getInvoiceFilter: state => state.invoiceFilter,
    getTempInvoiceList: state => state.tempInvoiceList,

    getCompanyTaxRates: state => state.companyTaxRates,
    getCreditableStatuses: state => state.creditableStatuses
  },
  mutations: {
    SET_INVOICE_TO_EDIT (state, invoiceToEdit) {
      state.invoiceToEdit = invoiceToEdit;
    },
    SET_INVOICE_NUMBER (state, invoiceNumber) {
      state.invoiceNumber = invoiceNumber;
    },
    SET_INVOICE_FILTER (state, invoiceFilter) {
      state.invoiceFilter = invoiceFilter;
    },
    SET_TEMP_INVOICE_LIST (state, invoiceList) {
      state.tempInvoiceList = invoiceList;
    },
    SET_COMPANY_TAX_RATES (state, taxRates) {
      state.companyTaxRates = taxRates;
    },
  },
  actions: {
    loadCompanyTaxRates ({ commit, rootGetters }) {
      return TaxRateService.list({ 'country': rootGetters['main/getCurrentCompany'].country }).then((response) => {
        // let data = $filter('orderBy')(response.data, "-value");
  
        let data = response.data
        for (let i = 0;i < data.length; i++) {
          data[i].name = data[i].taxrate+"%";
          data[i].order = data[i].taxrate;
        }
        commit('SET_COMPANY_TAX_RATES', response.data)
      })
    },
    loadInvoicesGlobalData ({ dispatch }) {
      return Promise.all([
        dispatch('loadCompanyTaxRates')
      ])
    },
  }
};
